<template>
	<div>
		<div class="image-panel">
			<app-image
				:image="imageUrl"
				:alt="value.title"
				:cropped="isImgix ? null : cropped"
				:size="isImgix ? null : size"
			/>
			<form-text
				v-if="!sortable"
				placeholder="Add a description"
				field-size="is-small"
				:name="imageName"
				:has-counter="true"
				:maxlength="150"
			/>
			<div class="image-actions">
				<span v-if="!sortable" class="has-text-grey" @click="onDelete">
					<dc-icon icon="trash" no-margin left-margin />
				</span>
				<span v-if="sortable" class="has-text-grey">
					<dc-icon icon="bars" no-margin left-margin />
				</span>
			</div>
			<span v-if="tag" class="tag is-black is-small" v-text="tag" />
		</div>
	</div>
</template>

<script>
import fieldMixin from "@lab/utils/fieldMixin";
import FormText from "@shared/form-v1/FormText";
import AppImage from "@/components/AppImage";
import VueSlider from "vue-slider-component";

export default {
	components: { FormText, AppImage },
	mixins: [fieldMixin],
	props: {
		onDelete: {
			type: Function,
			default: () => {}
		},
		tag: {
			type: String,
			default: () => null
		},
		cropped: {
			type: Boolean,
			default: () => false
		},
		size: {
			type: String,
			default: () => "is-16by9"
		},
		feature: {
			type: Boolean,
			default: () => false
		},
		sortable: {
			type: Boolean,
			default: () => false
		}
	},
	data() {
		return {
			focalX: 0,
			focalY: 0
		};
	},
	computed: {
		imageName() {
			return `${this.name}.title`;
		},
		imageUrl() {
			return `${this.value.url}${
				this.isImgix ? `?fit=crop&w=400&h=300` : ``
			}`;
		},
		notsaved() {
			return this.value.notsaved || false;
		},
		isImgix() {
			const pattern = new RegExp(/dailycare.imgix.net/g);
			return pattern.test(this.value.url);
		}
	}
};
// https://dailycare.imgix.net/URyMnvqpVbKKtGvObLbm.jpg
</script>

<style lang="scss" scoped>
.image-panel {
	position: relative;
	background-color: white;
}
.image-actions {
	position: absolute;
	top: 0;
	right: 0;
	background-color: rgba(white, 0.5);
	padding: 5px 10px 5px 3px;
	border-bottom-left-radius: 3px;
}
.tag {
	position: absolute;
	top: 1em;
	left: 1em;
}
.field {
	margin-top: 0.5em;
	margin-bottom: 0;
}
</style>
